import request from 'utils/request'

export const getMCAXS411InitRequest = () =>
  request({
    url: '/MCAXS411/init',
    method: 'post',
  })
